// extracted by mini-css-extract-plugin
export default {"onboard_thank_you":"OnBoardTenant_onboard_thank_you__953Jx"};